import * as React from "react";
import * as _ from "underscore";

import { PropertyRepairShape } from "@eave/shared/types/api";
import Money from "../../../Money";

const { FormattedNumber } = require("react-intl");

interface RepairSummaryProps {
  prefix: string;
  repairs: {
    map: Function;
    length: number;
    [index: number]: PropertyRepairShape;
  };
  salesPrice: number;
  costToCure: number;
  costToCurePercent: number;
}

class RepairSummary extends React.Component<RepairSummaryProps, any> {
  constructor(props) {
    super(props);

    // assumption is that we'll have three fields for each prefix:
    // -- in_<prefix>
    // -- <prefix>_cost_to_cure
    // -- <prefix>_note

    if (props.prefix !== "appraisal" && props.prefix !== "inspection") {
      throw new Error("prefix must be either 'appraisal' or 'inspection'");
    }
  }

  render() {
    const { prefix, repairs, salesPrice, costToCure, costToCurePercent } = this.props;

    const filtered = _.filter(repairs, (r: any) => r[`in_${prefix}`]);
    const ineligible = _.filter(filtered, (r: any) => r[`in_${prefix}`] && !r.eligible);
    const eligible = _.filter(filtered, (r: any) => r[`in_${prefix}`] && r.eligible);

    let repairTypes;
    if (ineligible.length > 0 && eligible.length > 0) {
      repairTypes = "Both ineligible and eligible";
    } else if (ineligible.length > 0) {
      repairTypes = "Ineligible only";
    } else if (eligible.length > 0) {
      repairTypes = "Eligible only";
    } else {
      return <div>No repairs indicated</div>;
    }

    const pctStr = (
      <span>
        <FormattedNumber
          value={costToCurePercent}
          style="decimal"
          minimumFractionDigits={0}
          maximumFractionDigits={2}
        />
        % of <Money value={salesPrice} />
      </span>
    );

    return (
      <table className="property-condition__summary-table">
        <tbody>
          <tr>
            <td>
              <strong>Repair types:</strong>
            </td>
            <td className="property-condition__summary-table-value">{repairTypes}</td>
          </tr>
          <tr>
            <td>
              <strong>Total cost to cure:</strong>
            </td>
            <td className="property-condition__summary-table-value">
              <Money value={costToCure} /> ({pctStr})
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default RepairSummary;
